<template>
  <div class="props-group form-basic-props">
    <el-tabs ref="formBasicCard" v-model="active" type="border-card" :before-leave="judgeClick">
      <el-tab-pane label="基本属性" name="first" class="basic-property">
        <el-form-item label="归档表" required>
          <el-select v-model="archive.tableId" @change="changeTable" filterable>
            <el-option v-if="showCurrentOption" :key="archive.defaultArchivedId" label="[当前表]" :value="archive.defaultArchivedId" />
            <el-option v-for="item in tableOptions" :key="item.id" :label="item | formatNew" :value="item.id" />
          </el-select>
        </el-form-item>
         <el-form-item class="form-screen" label="显示大小">
           <el-radio-group v-model="component.properties.formScreen">
              <el-radio label="full">全屏</el-radio>
              <el-radio label="middle">(大)600x800</el-radio>
              <el-radio label="small">(中)400x600</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item class="continue-create form-screen" label-width="0">
          <el-checkbox v-model="component.properties.continueCreate">提交后继续创建下一条</el-checkbox>
        </el-form-item>
      </el-tab-pane>
      <el-tab-pane label="控件交互" name="second">
        <component-interaction-attr ref="componentInteractions"  :componentInteraction="componentInteraction"></component-interaction-attr>
      </el-tab-pane>
      <el-tab-pane label="操作校验" name="third">
        <form-validate ref="formValidates" :formValidates="formValidates" :type="'form'"></form-validate>
      </el-tab-pane>
      <el-tab-pane label="数据联动" name="forth">
        <data-interactions ref="interactions" :linkages="interactions"></data-interactions>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ComponentInteractionAttr from '@/components/shared/component-interaction-attr.vue'
import FormValidate from '@/components/shared/operation-verification.vue'
import DataInteractions from '@/components/shared/data-interactions.vue'
import move from '@/plugins/move'
export default {
  name: 'attr-archived-table-attr',
  props: ['component', 'componentInteraction', 'formValidates', 'interactions', 'parentDom'],
  inject: ['formService'],
  components: {
    ComponentInteractionAttr,
    FormValidate,
    DataInteractions
  },
  data () {
    return {
      active: 'first',
      startMove: false
    }
  },
  methods: {
    changeTable () {
      if (this.archive.tableId !== this.archive.defaultArchivedId) {
        this.formService.loadTable(this.archive.tableId).then(() => {
          this.foreignKeyOptions = this.formService.getColumns(this.archive.tableId)
        })
      } else {
        this.foreignKeyOptions = this.formService.getColumns(this.archive.tableId)
      }
      this.archive.foreignKey = 'create'
    },
    verificationSubmit () {
      return this.$refs.formValidates.validate()
    },
    interactionSubmit () {
      return this.$refs.interactions.validate()
    },
    componentInteractionsSubmit () {
      return this.$refs.componentInteractions.validate()
    },
    judgeClick () {
      if (this.startMove) {
        this.startMove = false
        return false
      }
    }
  },
  computed: {
    archive () {
      return this.component.archive
    },
    tableOptions () {
      return this.formService.getAllTable()
    },
    showCurrentOption () {
      return !this.tableOptions.some(m => m.id === this.archive.defaultArchivedId)
    }
  },
  filters: {
    formatNew: (item) => item.isNew ? `${item.name}*` : item.name
  },
  mounted () {
    if (this.$refs.formBasicCard && this.$refs.formBasicCard.$el && this.$refs.formBasicCard.$el.firstChild) {
      let self = this
      move({
        drag: this.$refs.formBasicCard.$el.firstChild,
        dom: this.parentDom,
        end (e, distance) {
          if (Math.abs(distance.x) > 8 || Math.abs(distance.y) > 8) {
            if (!self.startMove) {
              self.startMove = true
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.form-design-dialog.formAttr {
  >.el-dialog {
    .el-dialog__header {
      background: inherit !important;
      padding: 0 !important;

      .el-dialog__headerbtn {
        z-index: 10;
      }
    }

    .el-dialog__body {
      padding: 0;

      .el-tabs {
        border: 0;
        box-shadow: none;
        .el-tabs__content .el-tab-pane:nth-child(1) {
         height: 140px;
        }
      }
    }
  }
}

.form-basic-props {
  .form-screen {
    .el-radio-group {
      .el-radio__inner {
        border-radius: 0;
      }

      .el-radio.is-checked {
        span.el-radio__label {
          color: #606266;
        }

        span.el-radio__input {
          width: 14px;
          height: 16px;
          display: inline-block;
          background: url('./assets/select.png') no-repeat;
          background-size: 14px;

          .el-radio__inner {
            display: none;
          }
        }
      }
    }
  }
  .basic-property {
    padding: 3px 0 0 56px;
    .is-required {
      .el-form-item__label {
        &::before {
          display: none;
        }
      }
    }
    .continue-create {
      .el-form-item__content {
        .is-checked {
          .el-checkbox__label {
            color: #606266;
          }
          .el-checkbox__inner {
            &::after {
              display: none;
            }
            width: 14px;
            height: 16px;
            display: inline-block;
            background: url('./assets/select.png') no-repeat;
            background-size: 14px;
            border: none;
          }
        }
        .is-focus {
          .el-checkbox__inner {
            border-color: #DCDFE6;
          }
        }
      }
    }
  }
  .el-tabs__header {
    div, span, p {
      user-select: none;
    }
  }
  border: 0;
  box-shadow: none;
  .el-tabs__nav {
    margin-left: 10px;
    #tab-first, #tab-second, #tab-third,#tab-fourth {
      position: relative;
      &::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 20px;
        position: absolute;
        top: 12px;
        right: 1px;
        background: #D2E0F4;
      }
    }
  }
  .el-tabs__header {
    background-color: #edeeee;
    border: 0;
    .el-tabs__item {
      height: 44px;
      line-height: 44px;
      color: #1A1A1A;
    }
    .is-active {
      border-bottom-width: 2px;
      border-bottom-color: #409EFF;
      color: #409EFF;
    }
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #edeeee;
    border-right-color: #edeeee;
    border-left-color: #edeeee;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #1A1A1A;
  }
  .el-tabs--border-card>.el-tabs__header .is-active:not(.is-disabled):hover {
    color: #409EFF;
  }
  .el-tabs--border-card>.el-tabs__header {
    background-color: #edeeee;
    border: 0;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item {
    color: #1A1A1A;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/archived-table-attr.vue